import { put, delay, call, cancelled } from 'redux-saga/effects';
import axios, { CancelToken } from 'axios';
import _ from 'lodash';
import { snackbarError } from 'store/Actions/UI/SnackbarActions';
import * as actionTypes from '../../Actions/Lists/ListActions';

export function* renderOverlay(action) {
  yield delay(500);
  yield document
    .getElementById(`mwb_subcat_display_${action.payload.id}`)
    .classList.add('active');
}

function* fetchDetails(action) {
  let oldDeatils;
  let prevID;

  // Fetch old id from parent previous slug

  if (action.payload.prevSlug !== undefined && action.payload.exist === false) {
    oldDeatils = yield axios.get('/template_cat', {
      params: {
        slug: action.payload.prevSlug,
      },
    });

    if (
      _.has(oldDeatils, 'data') &&
      oldDeatils.data.length > 0 &&
      _.has(oldDeatils.data[0], 'subcats') &&
      oldDeatils.data[0].subcats.length > 0
    ) {
      prevID = oldDeatils.data[0].id;
    } else if (
      _.has(oldDeatils, 'data') &&
      oldDeatils.data.length > 0 &&
      _.has(oldDeatils.data[0], 'subcats') &&
      oldDeatils.data[0].subcats.length === 0
    ) {
      prevID = oldDeatils.data[0].parent;
    }
  }

  // Check for category exist and it's subcategory
  if (
    action.payload.id !== undefined &&
    _.has(action.payload.subcatData, 'data') &&
    action.payload.exist === false
  ) {
    if (
      action.payload.subcatData.data.length > 0 &&
      _.has(action.payload.subcatData.data[0], 'subcats') &&
      action.payload.subcatData.data[0].subcats.length > 0
    ) {
      yield put(
        actionTypes.setSubcat(
          action.payload.subcatData.data[0].subcats,
          action.payload.id,
          action.payload.name,
          action.payload.slug,
          action.payload.url
        )
      );

      yield delay(500);
      if (
        document.getElementById(`mwb_subcat_display_${action.payload.id}`) !==
        null
      ) {
        yield document
          .getElementById(`mwb_subcat_display_${action.payload.id}`)
          .classList.add('active');
      }

      if (prevID !== undefined && prevID !== 0) {
        yield delay(500);
        if (document.getElementById(`mwb_subcat_display_${prevID}`) !== null) {
          yield document
            .getElementById(`mwb_subcat_display_${prevID}`)
            .classList.remove('active');
        }
        yield delay(500);
        yield put(actionTypes.filterSubcat(prevID));
      }
    } else {
      let categorySubcat;
      if (action.payload.subcatData.data[0].parent !== 0) {
        categorySubcat = yield axios.get('/template_cat', {
          params: {
            parent: action.payload.subcatData.data[0].parent,
          },
        });

        yield put(
          actionTypes.setSubcat(
            categorySubcat.data,
            action.payload.subcatData.data[0].parent_cat.id,
            action.payload.subcatData.data[0].parent_cat.name,
            action.payload.subcatData.data[0].parent_cat.slug,
            action.payload.subcatData.data[0].parent_cat.url
          )
        );

        yield delay(500);
        if (
          document.getElementById(
            `mwb_subcat_display_${action.payload.subcatData.data[0].parent_cat.id}`
          ) !== null
        ) {
          yield document
            .getElementById(
              `mwb_subcat_display_${action.payload.subcatData.data[0].parent_cat.id}`
            )
            .classList.add('active');
        }
      }

      if (prevID !== undefined && prevID !== 0) {
        yield delay(500);
        if (document.getElementById(`mwb_subcat_display_${prevID}`) !== null) {
          yield document
            .getElementById(`mwb_subcat_display_${prevID}`)
            .classList.remove('active');
        }
        yield delay(500);
        yield put(actionTypes.filterSubcat(prevID));
      }
    }
  } else if (action.payload.id === undefined) {
    if (prevID !== undefined && prevID !== 0) {
      if (document.getElementById(`mwb_subcat_display_${prevID}`) !== null) {
        yield document
          .getElementById(`mwb_subcat_display_${prevID}`)
          .classList.remove('active');
      }
      yield delay(500);
      yield put(actionTypes.filterSubcat(prevID));
    }
  }
}

export default function* fetchList(action) {
  try {
    yield call(fetchDetails, action);
  } catch (error) {
    yield delay(100);
    yield put(snackbarError('Some error occured'));
  } finally {
    yield put(actionTypes.setNavlink(''));
  }
}

export function* fetchTemplate(action) {
  const source = CancelToken.source();

  try {
    let templateList;
    yield put(actionTypes.setTemplate(true));
    if (action.payload.slug === undefined || action.payload.slug === '') {
      let searchParam;
      if (
        action.payload.search !== null &&
        action.payload.search !== undefined &&
        action.payload.search !== ''
      ) {
        searchParam = {
          page: action.payload.page,
          per_page: 15,
          search: action.payload.search,
        };
      } else {
        searchParam = {
          page: action.payload.page,
          per_page: 15,
        };
      }

      templateList = yield axios.get('/template', {
        params: searchParam,
        cancelToken: source.token,
      });
    } else {
      let searchParam;
      if (
        action.payload.search !== null &&
        action.payload.search !== undefined &&
        action.payload.search !== ''
      ) {
        searchParam = {
          page: action.payload.page,
          per_page: 15,
          search: action.payload.search,
        };
      } else {
        searchParam = {
          page: action.payload.page,
          per_page: 15,
          template_cat: action.payload.slug,
        };
      }

      templateList = yield axios.get('/template', {
        params: searchParam,
        cancelToken: source.token,
      });
    }

    yield put(actionTypes.setTemplate(false));

    yield put(
      actionTypes.updateCount(Number(templateList.headers['x-wp-totalpages']))
    );
    yield put(actionTypes.appHeading(templateList.headers['app-heading-text']));
    if (templateList.data.length > 0) {
      yield put(actionTypes.setList(templateList.data, 'TemplateList'));
    }
  } catch (error) {
    yield delay(100);
    yield put(snackbarError('Some error occured'));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
    if (window.innerWidth <= 992) {
      yield window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    } else {
      const elmnt = document.getElementById('mwb_main_listing');
      yield elmnt.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}

export function* fetchCats() {
  try {
    const allcats = {};
    const categoryList = yield axios.get('/template_cat', {
      params: { parent: 0 },
    });

    const resultempty = categoryList.data.filter(
      (element) => element.cat_group === null
    );

    if (resultempty.length > 0) {
      allcats.emptyGroup = resultempty;
    }

    const resultlist = categoryList.data.filter(
      (element) =>
        element.cat_group !== null &&
        Object.keys(element.cat_group).length !== 0
    );

    const categories = _.groupBy(
      _.sortBy(resultlist, ['cat_group.order'], ['asc']),
      'cat_group.name'
    );

    if (resultlist.length > 0) {
      Object.keys(categories).forEach((element) => {
        allcats[element] = categories[element];
      });
    }

    yield put(actionTypes.setList(allcats, 'CategoryList'));
  } catch (error) {
    yield put(snackbarError('Some error occured'));
  }
}
